<template>
  <div class="c-home-icon-content">
    <div class="c-home-icon-content__headlines">
      <h1 v-if="fields && fields.headlineh1" v-html="fields.headlineh1.value" />
      <h2 v-if="fields && fields.headlineh2" v-html="fields.headlineh2.value" />
    </div>
    <div class="c-home-icon-content__inner">
      <div class="c-home-icon-content__copy">
        <sc-image
          class="c-home-icon-content__image"
          v-if="fields && fields.image"
          :media="fields.image"
        />
        <sc-text
          tag="h2"
          v-if="fields && fields.heading"
          :field="fields.heading"
          class="c-home-icon-content__heading"
        />
        <sc-richText
          class="c-home-icon-content__content"
          v-if="fields && fields.content"
          :field="fields.content"
        />
        <sc-link
          v-if="fields && fields.cta && fields.cta.value && fields.cta.value.text"
          :field="fields.cta"
          class="c-cta--primary"
          :class="fields.cta.value.class"
          >{{ fields?.cta?.value?.text }}
          <span class="sr-only">{{ fields?.heading?.value }}</span></sc-link
        >
      </div>
      <div class="spacer" v-if="rendering?.placeholders['jss-home-icon-content']?.length > 0"></div>
      <div
        class="c-home-icon-content__callouts"
        v-if="rendering?.placeholders['jss-home-icon-content']?.length > 0"
      >
        <sc-placeholder name="jss-home-icon-content" :rendering="rendering" />
      </div>
    </div>
  </div>
</template>

<script>
import { Text, RichText, Image, Link, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-Icon-Content',
  components: {
    ScText: Text,
    ScRichText: RichText,
    ScImage: Image,
    ScLink: Link,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-home-icon-content {
  max-width: 117.6rem;
  margin: 5rem auto 5rem auto;

  &__headlines {
    padding: 0 4rem 4rem 4rem;

    @include large-desktop-up {
      padding: 0;
    }
  }

  &__inner {
    @include padding-x(4rem);
    @include padding-y(4rem);
    @include margin-x(auto);

    background: linear-gradient(
      169deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 59, 92, 1) 20%,
      rgba(0, 134, 191, 1) 100%
    );

    @include tablet-up {
      display: flex;
      flex-direction: row;
      gap: 4rem;
    }

    .spacer {
      width: 2px;
      background-color: $orange;
    }
  }

  &__copy {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .c-cta--primary {
      width: fit-content;
      min-width: fit-content;
      padding-left: 4rem;
      padding-right: 4rem;
      margin-bottom: 0;
    }
  }

  &__callouts {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    padding: 4rem 2rem 0 2rem;

    @include tablet-up {
      padding: 0;
      gap: 3.2rem;
    }
  }

  &__image {
    display: block;
    margin-bottom: 1.6rem;
  }

  &__heading {
    @include font-styles('Arial Narrow', 2.4rem, 300, normal, 3rem, 0, $white);
    margin-bottom: 2rem;
    -webkit-text-fill-color: $white !important;

    @include tablet-up {
      font-size: 3.6rem;
      line-height: 4.2rem;
    }
  }

  &__content {
    @include font-styles('Arial', 1.6rem, 200, normal, 2.2rem, 0, $white);
    margin-bottom: 3.2rem;

    @include tablet-up {
      font-size: 2rem;
      line-height: 2.6rem;
    }

    strong {
      font-weight: 600;
    }
  }
}
</style>
